import procedureReducers from './reducer';
import * as procedureActions from './reducer';

export { procedureActions };

export default procedureReducers;
